import { useState } from "react";
import axios from "axios";
import { motion } from "framer-motion";
import { toast } from "sonner";
import { Mail, Send, Loader2, Check } from "lucide-react";
import { Input } from "@/components/ui/input";

const API = `${process.env.REACT_APP_BACKEND_URL}/api`;

const Newsletter = () => {
  const [email, setEmail] = useState("");
  const [loading, setLoading] = useState(false);
  const [done, setDone] = useState(false);

  const submit = async (e) => {
    e.preventDefault();
    if (!email) {
      toast.error("Merci d'indiquer votre adresse email.");
      return;
    }
    setLoading(true);
    try {
      await axios.post(`${API}/newsletter/subscribe`, { email });
      toast.success("Merci ! Vous êtes bien inscrit·e à notre lettre gourmande.");
      setDone(true);
      setEmail("");
    } catch (err) {
      if (err.response?.status === 409) {
        toast.info("Cette adresse est déjà inscrite. À bientôt !");
      } else {
        toast.error("Une erreur est survenue. Merci de réessayer.");
      }
    } finally {
      setLoading(false);
    }
  };

  const buttonLabel = () => {
    if (loading) return <><Loader2 size={18} className="animate-spin" /> Envoi...</>;
    if (done) return <><Check size={18} /> Inscrit·e</>;
    return <><Send size={18} /> S'inscrire</>;
  };

  return (
    <section data-testid="newsletter-section" id="newsletter" className="py-24 lg:py-28 bg-bordeaux">
      <div className="max-w-3xl mx-auto px-6 lg:px-10 text-center">
        <motion.div
          initial={{ opacity: 0, y: 30 }}
          whileInView={{ opacity: 1, y: 0 }}
          viewport={{ once: true }}
          transition={{ duration: 0.6 }}
        >
          <span className="inline-flex w-14 h-14 rounded-2xl bg-white/12 text-white items-center justify-center mb-5">
            <Mail size={26} />
          </span>
          <span className="block text-sm uppercase tracking-[0.3em] text-white/70 font-500">Restons gourmands</span>
          <h2 className="font-heading text-4xl sm:text-5xl text-white mt-2 tracking-tight">
            La lettre d'Escarg'Holala
          </h2>
          <p className="text-lg text-white/80 mt-5 leading-relaxed max-w-xl mx-auto">
            Recevez nos actualités, la disponibilité de nos produits et les prochains salons &
            événements gourmands où nous retrouver. Pas de spam, seulement le meilleur de la Bourgogne.
          </p>

          <form
            data-testid="newsletter-form"
            onSubmit={submit}
            className="mt-9 flex flex-col sm:flex-row items-stretch gap-3 max-w-xl mx-auto"
          >
            <Input
              data-testid="newsletter-email-input"
              type="email"
              value={email}
              onChange={(e) => setEmail(e.target.value)}
              placeholder="votre@email.fr"
              className="bg-white h-12 flex-1 text-base"
            />
            <button
              data-testid="newsletter-submit"
              type="submit"
              disabled={loading}
              className="rounded-full bg-creme text-bordeaux font-600 px-7 h-12 hover:bg-white transition-all flex items-center justify-center gap-2 disabled:opacity-70 whitespace-nowrap"
            >
              {buttonLabel()}
            </button>
          </form>
          <p className="text-xs text-white/55 mt-4">
            En vous inscrivant, vous acceptez de recevoir nos communications. Désinscription possible à tout moment.
          </p>
        </motion.div>
      </div>
    </section>
  );
};

export default Newsletter;
